'use client';

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import Link from 'next/link';
import Image from 'next/image';
import styles from '../styles/Prices.module.css';

const Prices = () => {
  const headingRef = useRef(null);
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    
    const heading = headingRef.current;
    if (!heading) return;
    
    // Use SplitType to match the original animation
    const splitPrice = new SplitType(heading, {
      types: "words, chars",
    });
    
    // Create the timeline with ScrollTrigger
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `.${styles.prices}`,
        start: "top 90%",
        end: "+=100%",
        scrub: 0.5,
      },
    });
    
    // Animate each character
    tl.set(splitPrice.chars, {
      duration: 0.3,
      color: "#fff",
      stagger: 0.1,
    }, 0.1);
    
    // Hover effect for the app store buttons
    const appleButton = document.querySelector(`.${styles.appStoreButton}`);
    const androidButton = document.querySelector(`.${styles.playStoreButton}`);
    
    const addHoverEffect = (element) => {
      if (element) {
        element.addEventListener('mouseenter', () => {
          gsap.to(element, {
            boxShadow: '0px 0px 30px 0px rgba(54, 211, 0, 0.75)',
            scale: 1.05,
            duration: 0.3
          });
        });
        
        element.addEventListener('mouseleave', () => {
          gsap.to(element, {
            boxShadow: '0px 0px 10px 0px rgba(54, 211, 0, 0.3)',
            scale: 1,
            duration: 0.3
          });
        });
      }
    };
    
    addHoverEffect(appleButton);
    addHoverEffect(androidButton);
    
  }, []);
  
  return (
    <section className={styles.prices}>
      <div className={styles.pricesHeader}>
        <div className={styles.pricesCol}>
          <div className={styles.appImageContainer}>
            <Image 
              src="https://imagedelivery.net/LOBxX7gyPpyC22XVZKaoOw/ffc36049-cc0a-4626-ca86-b38982c4f300/public"
              alt="GAM App"
              width={400}
              height={800}
              className={styles.appImage}
              priority
            />
          </div>
        </div>
        <div className={styles.pricesCol}>
          <h3 ref={headingRef}>
          Your ultimate pickleball tool. Play and earn rewards, compete in AI-Powered Challenger Mode with real-time coaching, and access AI-driven training to boost your performance. Easily find courts, connect with players, and take your game to the next level—all in one app.
            <span style={{ opacity: 0 }}>.</span>
          </h3>

          <p className={styles.pricesCopy}>
            MVP Released.
          </p>
        </div>
      </div>

      <div className={styles.appStoreButtons}>
        <a 
          href="https://apps.apple.com/us/app/GameMax/id6480151776?ct=Tap33743133" 
          target="_blank" 
          rel="noopener noreferrer"
          className={styles.appStoreButton}
        >
          <div className={styles.buttonContent}>
            <div className={styles.buttonIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24" height="24" fill="currentColor">
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
              </svg>
            </div>
            <div className={styles.buttonText}>
              <span className={styles.buttonSmallText}>Download on the</span>
              <span className={styles.buttonLargeText}>App Store</span>
            </div>
          </div>
        </a>
        
        <a 
          href="#" 
          target="_blank" 
          rel="noopener noreferrer"
          className={styles.playStoreButton}
        >
          <div className={styles.buttonContent}>
            <div className={styles.buttonIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24" fill="currentColor">
                <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
              </svg>
            </div>
            <div className={styles.buttonText}>
              <span className={styles.buttonSmallText}>GET IT ON</span>
              <span className={styles.buttonLargeText}>Google Play</span>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default Prices; 
